import React, { useState } from 'react';

// Import CSS & assets
import ico_ia_stars from '../../../../assets/ico/ico_ia_3_stars.svg';
import ico_check from '../../../../assets/ico/ico_check.svg';

import * as AI_helpers from '../../../../helpers/AI_helpers';
import * as PDF_helpers from '../../../../helpers/PDF_helpers';

var backup_rules = null;
var var_capacity = null;
var main_doc = null;
var llamaparse_job_id = null;

var test_data = {
    // llamaparse_job_id: "7cc10e3a-10de-44f8-a370-f67a4eb60ab3",
    llamaparse_job_id: "600b9046-9064-488e-b84d-5664e7a2314e",
    // llamaparse_job_result: test_result_parsing_summary,
}


var test_result_parsing_summary = ` Plan Local
 d'Urbanisme
 intercommunal
           4. Règlement
           —
           4.Règlement écrit
           —
              Vu pour être annexé à la délibération du Conseil de Territoire
              du 11 décembre 2024 approuvant le projet de PLUi
     [PLUil
GRANDPARIS
SEINE                                                             7 février 2024
 BOULOGNE-BILLANCOURT      CHAVILLE     ISSY-LES-MOULINEAUX     MARNES-LA-COQUETTE     MEUDON       SÈVRES      VANVES       VILLE-D’AVRAY
OIEST
---
NO_CONTENT_HERE
---
1.     Dispositions générales                                                                       6
    1.1.    Champ d'application                                                                     7
    1.2.    Contenu du règlement                                                                    7
    1.3.    Articulation du règlement avec d’autres dispositions                                   10
    1.4.    Lexique réglementaire                                                                  13
2. Affectation des sols, destination des constructions et natures d'activités                      36
    2.1.    Zones urbaines                                                                         37
    2.2.    Zone naturelle                                                                         45
    2.3.    Autres périmètres et secteurs particuliers                                             50
3. Morphologie et implantation des constructions                                                   51
  Zone U1 Centralités                                                                              52
    3.1.    Implantation par rapport aux emprises publiques et aux voies                           54
    3.2.    Implantation par rapport aux limites séparatives                                       63
    3.3.    Implantation sur un même terrain                                                       77
    3.4.    Emprise au sol                                                                         83
    3.5.    Hauteur                                                                                85
  Zone U2 Secteurs mixtes de transition                                                            98
    3.1.    Implantation par rapport aux emprises publiques et aux voies                           99
    3.2.    Implantation par rapport aux limites séparatives                                      104
    3.3.    Implantation sur un même terrain                                                      111
    3.4.    Emprise au sol                                                                        114
    3.5.    Hauteur                                                                               116    3
  Zone U3 Dominante habitat pavillonnaire                                                         123
    3.1.    Implantation par rapport aux emprises publiques et aux voies                          124
    3.2.    Implantation par rapport aux limites séparatives                                      131
    3.3.    Implantation sur un même terrain                                                      142
    3.4.    Emprise au sol                                                                        146
    3.5.    Hauteur                                                                               149
  Zone U4 Grands quartiers résidentiels et mixtes                                                 154
    3.1.    Implantation par rapport aux emprises publiques et aux voies                          155
    3.2.    Implantation par rapport aux limites séparatives                                      161
    3.3.    Implantation sur un même terrain                                                      168
    3.4.    Emprise au sol                                                                        172
    3.5.    Hauteur                                                                               174
  Zone U5 Zones d’activités économiques                                                           182
    3.1.    Implantation par rapport aux emprises publiques et aux voies                          183
    3.2.    Implantation par rapport aux limites séparatives                                      187
    3.3.    Implantation sur un même terrain                                                      190
    3.4.    Emprise au sol                                                                        192
    3.5.    Hauteur                                                                               193
  Zone U6 Équipements spécifiques                                                                 196
    3.1.    Implantation par rapport aux emprises publiques et aux voies                          197
    3.2.    Implantation par rapport aux limites séparatives                                      199
                                         11 décembre 2024
---
        3.3.   Implantation sur un même terrain                                                        202
        3.4.   Emprise au sol                                                                          204
        3.5.   Hauteur                                                                                 205
      Zone N Zone naturelle                                                                            209
        3.1.   Implantation                                                                            210
        3.2.   Emprise au sol                                                                          210
        3.3.   Hauteur                                                                                 210
    4. Nature et biodiversité                                                                          212
        4.1.   Taux de pleine-terre                                                                    213
        4.2.   Coefficient de biotope surfacique                                                       216
        4.3.   Espaces écologiques et/ou paysagers protégés                                            218
        4.4.  Traitement environnemental et paysager des espaces non bâtis et des abords des constructions
                                                                                                       221
        4.5.   Lisières forestières                                                                    223
        4.6.   Emplacements réservés aux espaces verts et continuités écologiques                      224
        4.7.   Espaces boisés classés                                                                  224
    5.   Qualité    urbaine,    architecturale,     énergétique      et   environnementale        des
    constructions                                                                                      225
        5.1.   Aspect extérieur                                                                        226
        5.2.   Performance énergétique et environnementale                                             232
        5.3.   Fonctionnalisation des toitures                                                         233
4   6. Patrimoine bâti et paysager                                                                     234
        6.1.   Définitions des catégories de patrimoine protégé                                        235
        6.2.   Dispositions relatives au patrimoine bâti et urbain                                     235
        6.3.   Dispositions relatives au patrimoine paysager                                           238
        6.4.   Règle alternative                                                                       238
        6.5.   Aqueducs du réseau hydraulique du domaine de Saint-Cloud                                239
    7. Mixité fonctionnelle et sociale                                                                 240
        7.1.   Mixité fonctionnelle                                                                    241
        7.2.   Mixité sociale                                                                          242
    8. Stationnement                                                                                   245
        8.1.   Stationnement des véhicules motorisés                                                   246
        8.2.   Stationnement des vélos                                                                 256
    9. Équipements et réseaux                                                                          259
        9.1.   Gestion des eaux                                                                        260
        9.2.   Desserte par les voies publiques ou privées                                             262
        9.3.   Desserte par les réseaux                                                                263
        9.4.   Emplacements réservés  (voies, ouvrages publics, installations d’intérêt général)       264
        9.5.   Servitudes de localisation                                                              264
        9.6.   Voies, sentes ou chemins à préserver                                                    264
    10. Cahiers réglementaires détaillés                                                               265
        10.1.  Cahier des patrimoines                                                                  266
        10.2.  Cahier des emplacements réservés                                                        267
                                             11 décembre 2024
---
10.3.      Cahier des servitudes de localisation ......................................................................................267
10.4.                        Cahier des espaces écologiques et/ou paysagers protégés...................................................267
10.5.      Cahier des gabarits-enveloppes..............................................................................................268
10.6.  Cahier des plans-masses ........................................................................................................272
10.7.     Cahier des références aux voiries ...........................................................................................273
10.8.   Schéma délimitant les îlots de la ZAC Seguin Rives de Seine           –                                     Possibilités maximales
d’occupation du sol pour chaque îlot (en m² de SDP)..........................................................................285
10.9.                                      Possibilités maximales d’occupation du sol (en m² de sdp) pour la ZAC Centre-ville de Boulogne-
Billancourt.............................................................................................................................................286
                                                                                                            5
                                       11 décembre 2024`




const AIplu = ({ capacity, setCapacity, ruleGroup_Update }) => {

    const [isLaunching, setIsLaunching] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [isAskingRules, setIsAskingRules] = useState(false);
    const [runningStep, setRunningStep] = useState(0);
    const [runningStepStatus, setRunningStepStatus] = useState("loading");
    const [analysedDocs, setAnalysedDocs] = useState("");
    const stepList = [
        {
            number: "0",
            description: "Extraction du document principal",
        },
        {
            number: "1",
            description: "Analyse de la structure du document",
        },
        {
            number: "2",
            description: "Création des titres et sous-titres",
        },
        {
            number: "3",
            description: "Identification des règles",
        },
    ]
    const [step1_status, set_step1_status] = useState("none");
    const [step1_description, set_step1_description] = useState("");
    const [step2_status, set_step2_status] = useState("none");
    const [step2_description, set_step2_description] = useState("");
    const [step3_status, set_step3_status] = useState("none");
    const [step3_description, set_step3_description] = useState("");

    const switchRunning = () => {
        setIsRunning(!isRunning);
    }

    const handleRunClick = () => {
        // Scroll to rules section and animate launch button
        scroll_to_rules();
        setIsLaunching(true);
        // Set capacity as var to access data
        if (var_capacity === null) {
            var_capacity = { ...capacity };
        }
        // Check if already rules
        backup_rules = var_capacity?.rules?.ruleset || null;
        console.log("EXISTING RULES", backup_rules);
        if (backup_rules === null) {
            setTimeout(() => {
                handleAskRules_Erase();
            }, 200)
        }
        else if (backup_rules.length > 1 || (backup_rules.length === 1 && backup_rules[0]?.items && backup_rules[0].items.length > 0)) {
            setTimeout(() => {
                setIsAskingRules(true);
            }, 500)
        }
        else {
            setTimeout(() => {
                startRunning();
            }, 200)
        }
    }

    const handleAskRules_Keep = () => {
        // Update capacity by adding ruleset at first place
        var new_rules = { ...var_capacity.rules };
        var id_seed = (Date.now()).toString();
        new_rules.ruleset.unshift({
            id: "ruleGroup_" + id_seed,
            name: "Règlement",
            items: [],
            numerotation: "0.",
            isFromAI: true
        });
        var toSaveData = { ...var_capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules");
        toSaveData.autoSave = false;
        toSaveData.action = "Règlement mis à jour avec";
        toSaveData.value = "l'outil d'analyse IA";
        setCapacity({ ...var_capacity, rules: new_rules, toSave: toSaveData });
        var_capacity = { ...var_capacity, rules: new_rules, toSave: toSaveData };
        // Start AI
        setIsAskingRules(false);
        startRunning();
    }

    const handleAskRules_Erase = () => {
        // Update capacity with empty ruleset
        var new_rules = { ...var_capacity.rules };
        new_rules.ruleset = [
            {
                id: "ruleGroup_0",
                name: "Règlement",
                items: [],
                numerotation: "0.",
                isFromAI: true
            }
        ]
        var toSaveData = { ...var_capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules");
        toSaveData.autoSave = false;
        toSaveData.action = "Règlement mis à jour avec";
        toSaveData.value = "l'outil d'analyse IA";
        setCapacity({ ...var_capacity, rules: new_rules, toSave: toSaveData });
        var_capacity = { ...var_capacity, rules: new_rules, toSave: toSaveData };
        // Update UI of ruleset title
        var dom_title = document.getElementById("ruleGroup_0_title");
        if (dom_title) {
            dom_title.value = "Règlement";
        }
        // Start AI
        setIsAskingRules(false);
        startRunning();
    }

    const startRunning = () => {
        // Lanch
        // setTimeout(() => {
        setIsRunning(true);
        get_main_doc_start();
        // setTimeout(() => {
        //     setNextStep(0);
        // }, 2000)
        // setTimeout(() => {
        //     setNextStep(1);
        // }, 4000)
        // setTimeout(() => {
        //     setNextStep(2);
        // }, 6000)
        // setTimeout(() => {
        //     stopRunning();
        // }, 10000)
        // }, 500)
    }

    const stopRunning = () => {
        setIsLaunching(false);
        setIsRunning(false);
        setIsAskingRules(false);
        setRunningStep(0);
        setAnalysedDocs("");

        set_step1_status("none");
        set_step1_description("");
        set_step2_status("none");
        set_step2_description("");
        set_step3_status("none");
        set_step3_description("");
    }

    const setNextStep = (current_step) => {
        if (stepList.length > current_step + 1) {
            setRunningStepStatus("done");
            setTimeout(() => {
                setRunningStep(current_step + 1);
                if (current_step + 1 === 1) {
                    get_doc_structure_start();
                }
                setTimeout(() => {
                    setRunningStepStatus("loading");
                }, 300)
            }, 500)
        }
    }

    // STEPS
    // 0 GET MAIN DOC
    const get_main_doc_start = () => {
        set_step1_status("loading");
        set_step1_description("Recherche du document");
        setTimeout(() => {
            try {
                main_doc = var_capacity?.rules?.gpu_data?.files["Règlements"]["Règlements écrits"][0];
            } catch (error) {
                main_doc = null;
            }
            if (main_doc !== null) {
                console.log("STEP 0 - Main Doc found", main_doc);
                get_main_doc_found();
            }
            else {
                stopRunning();
            }
        }, 1800)
    }
    const get_main_doc_found = () => {
        set_step1_status("done");
        set_step1_description("Document principal identifié");
        // Set values
        // setAnalysedDocs("Doc de test");
        handleDocumentChange(main_doc?.title || "Règlement");
    }

    // 1 GET DOC STRCTURE
    const get_doc_structure_start = async () => {
        set_step2_status("loading");
        set_step2_description("");
        
        var main_doc_summary = await PDF_helpers.pdfParser_get_summary(main_doc);
        console.log("main_doc_summary", main_doc_summary);
        set_step2_status("done");
        set_step2_description("Le document contient " + main_doc_summary.length + " sections");
        set_step3_status("loading");
        set_step3_description("");
        AI_helpers.openRouter_summary_select(main_doc_summary, capacity?.rules?.gpu_data?.zoneUrba || []);

        // var llamaparse_upload = null;
        // if (test_data?.llamaparse_job_id) {
        //     llamaparse_upload = {
        //         id: test_data.llamaparse_job_id,
        //         status: "PENDING"
        //     };
        // }
        // else {
        //     llamaparse_upload = await AI_helpers.llamaparse_upload(main_doc?.url);
        // }
        // console.log("llamaparse_upload", llamaparse_upload);
        // if (llamaparse_upload?.id) {
        //     llamaparse_job_id = llamaparse_upload.id;
        // }
        // setTimeout(() => {
        //     if (llamaparse_upload?.status === "PENDING") {
        //         get_doc_structure_llamaparse_status();
        //     }
        //     // get_doc_structure_found();
        // }, 3000)
    }
    const get_doc_structure_llamaparse_status = async () => {
        var llamaparse_status = await AI_helpers.llamaparse_status(llamaparse_job_id);
        console.log("llamaparse_status", llamaparse_status);
        if (llamaparse_status?.status === "PENDING") {
            setTimeout(() => {
                get_doc_structure_llamaparse_status();
            }, 2000)
        }
        else if (llamaparse_status?.status === "SUCCESS") {
            get_doc_structure_llamaparse_values();
        }
        else {
            console.log("ERROR LLAMAPARSE UPLOAD");
            stopRunning();
        }
    }
    const get_doc_structure_llamaparse_values = async () => {
        var llamaparse_values = null;
        if (test_data?.llamaparse_job_result) {
            llamaparse_values = {
                text: test_data.llamaparse_job_result,
            };
        }
        else {
            llamaparse_values = await AI_helpers.llamaparse_result(llamaparse_job_id);
        }
        console.log("llamaparse_values", llamaparse_values);
        if (llamaparse_values?.text) {
            get_doc_structure_ollama(llamaparse_values.text);
        }
    }
    const get_doc_structure_ollama = async (raw_text) => {
        var ollama_summary = await AI_helpers.ollama_ask_summary(raw_text);
        console.log("ollama_summary", ollama_summary);
    }
    const get_doc_structure_found = () => {
        var docStructure = [
            {
                label: "Dispositions générales",
                linkPage: 12,
                children: []
            },
            {
                label: "Occupations du sol",
                linkPage: 15,
                children: []
            },
        ]

        // Loop to create all titles
        handleTitleCreateList(docStructure, 0);

        setTimeout(() => {
            stopRunning();
        }, 4000)
    }

    // UI MANIPULATIONS

    const scroll_to_rules = () => {
        var target_id = "section_5_rules";
        var delta = 0;
        var section_id = target_id.substring(0, 9);
        var section_dom = document.getElementById(section_id);
        var target_dom = document.getElementById(target_id);
        if (section_dom && target_dom) {
            var section_top = section_dom.offsetTop;
            var target_top = target_dom.offsetTop;
            document.getElementById("section_data").scrollTop = section_top + target_top + delta + 10;
        }
    }

    // RULES MANIPULATIONS

    const handleDocumentChange = (newDocName) => {
        // Get id and name of ruleset
        var ruleGroup_Name = "";
        var ruleGroup_Id = null;
        if (var_capacity?.rules?.ruleset && var_capacity?.rules?.ruleset.length > 0 && var_capacity?.rules?.ruleset[0]?.name && var_capacity?.rules?.ruleset[0]?.id) {
            ruleGroup_Name = var_capacity?.rules?.ruleset[0]?.name;
            ruleGroup_Id = var_capacity?.rules?.ruleset[0]?.id;
        }
        // Get current rules
        var new_rules = { ...var_capacity.rules };
        if (ruleGroup_Id !== null && ruleGroup_Name !== newDocName) {
            // Update ruleset
            new_rules.ruleset.forEach(ruleGroup => {
                if (ruleGroup.id === ruleGroup_Id) {
                    ruleGroup.name = newDocName;
                    ruleGroup.isFromAI = true;
                }
            })
            // Set numerotation
            // rules = rulesHelpers.getRulesNumerotation(rules);
            // Update capacity
            var toSaveData = { ...var_capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Règlement mis à jour avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...var_capacity, rules: new_rules, toSave: toSaveData });
            var_capacity = { ...var_capacity, rules: new_rules, toSave: toSaveData };
        }
        // Next step
        setNextStep(0);
    }

    const handleTitleCreateList = (list, currentIndex) => {
        // Get id of ruleset
        var documentId = null;
        if (var_capacity?.rules?.ruleset && var_capacity?.rules?.ruleset.length > 0 && var_capacity?.rules?.ruleset[0]?.name && var_capacity?.rules?.ruleset[0]?.id) {
            documentId = var_capacity?.rules?.ruleset[0]?.id;
        }
        console.log("CREATE TITLE", documentId);
        // Create new element model
        var titleNew = { id: (Date.now()).toString(), name: list[currentIndex]?.label || "Nouveau titre", type: "title", isFromAI: true };
        // Get current rules
        var new_rules = { ...var_capacity.rules };
        // Get current ruleset
        var ruleset = new_rules.ruleset;
        // Add title
        ruleset.forEach(ruleGroup => {
            if (ruleGroup.id === documentId) {
                ruleGroup.items.push(titleNew);
            }
        })
        // Set numerotation
        // rules = rulesHelpers.getRulesNumerotation(rules);
        // Save part
        var toSaveData = { ...var_capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules");
        toSaveData.autoSave = false;
        toSaveData.action = "Règlement mis à jour avec";
        toSaveData.value = "l'outil d'analyse IA";
        // Update capacity
        setCapacity({ ...var_capacity, rules: new_rules, toSave: toSaveData });
        var_capacity = { ...var_capacity, rules: new_rules, toSave: toSaveData };
        // Next
        if (list.length > currentIndex + 1) {
            setTimeout(() => {
                handleTitleCreateList(list, currentIndex + 1);
            }, 800)
        }
        else {
            // Next step
            setNextStep(1);
        }
    }

    return (
        <div className="">
            <div className="app__sectiondata_widget_spacer_10"></div>
            <div className="app__ai_container_main">
                {/* <div className={`app__ai_container_shadow ${isRunning ? "app__ai_container_shadow_running" : ""}`}></div> */}
                <div className={`app__sectiondata__widget app__ai_container ${isLaunching ? "app__ai_container_glowing" : ""}`}>
                    {/* LANCH BUTTON */}
                    <div className={`app__ai_start_button ${isLaunching ? "app__ai_start_button_running app__ai_start_button_hidden" : ""}`} onClick={() => { handleRunClick() }}>
                        <img src={ico_ia_stars} />
                        Lancez notre IA pour analyser le PLU
                    </div>
                    {/* QUESTION - EXISTING STRUCRE KEEP */}
                    {isAskingRules &&
                        <div className="app__ai_ask_container">
                            <div className="app__ai_ask_text">Souhaitez-vous supprimer les règles existantes avant de lancer l'analyse ?</div>
                            <div className="app__ai_ask_rep_container">
                                <div className="app__ai_ask_rep_item" onClick={() => { handleAskRules_Erase() }}>Supprimer les règles</div>
                                <div className="app__ai_ask_rep_item" onClick={() => { handleAskRules_Keep() }}>Conserver les règles</div>
                            </div>
                        </div>
                    }
                    {/* STEPS */}
                    <div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step1_status === "loading" ? "app__ai_step_container_loading" : ""} ${step1_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className="app__ai_step_status"><img src={ico_check} /></div>
                                Etape 1 : Identification du document principal
                            </div>
                            <div className={`app__ai_step_description_none ${step1_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step1_description}</div>
                            <div className={`app__ai_step_status_link ${step1_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div>
                        </div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step2_status === "loading" ? "app__ai_step_container_loading" : ""} ${step2_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className={`app__ai_step_status`}><img src={ico_check} /></div>
                                Etape 2 : Extraction de la structure du document
                            </div>
                            <div className={`app__ai_step_description_none ${step2_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step2_description}</div>
                            <div className={`app__ai_step_status_link ${step2_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div>
                        </div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step3_status === "loading" ? "app__ai_step_container_loading" : ""} ${step3_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className={`app__ai_step_status`}><img src={ico_check} /></div>
                                Etape 3 : Analyse des sections du document
                            </div>
                            <div className={`app__ai_step_description_none ${step3_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step3_description}</div>
                            {/* <div className={`app__ai_step_status_link ${step3_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div> */}
                        </div>
                    </div>
                    {/* {isRunning ?
                        <>
                            <div className="app__ai_steps_container">
                                {stepList.map((item, index) => {
                                    return (
                                        <div className={`app__ai_step_container ${runningStep === index ? "app__ai_step_container_current" : ""} ${runningStep > index ? "app__ai_step_container_old" : ""}`}>
                                            <div className={`app__ai_step_status ${runningStepStatus === "done" ? "app__ai_step_status_done" : ""}`}><img src={ico_check} /></div>
                                            Etape {item.number} : {item.description}
                                        </div>
                                    )
                                })}
                            </div>
                        </>
                        :
                        <>
                            {isAskingRules ?
                                <div className="app__ai_ask_container">
                                    <div className="app__ai_ask_text">Souhaitez-vous supprimer les règles existantes avant de lancer l'analyse ?</div>
                                    <div className="app__ai_ask_rep_container">
                                        <div className="app__ai_ask_rep_item" onClick={() => { handleAskRules_Erase() }}>Supprimer les règles</div>
                                        <div className="app__ai_ask_rep_item" onClick={() => { handleAskRules_Keep() }}>Conserver les règles</div>
                                    </div>
                                </div>
                                :
                                <>
                                    <div className="app__ai_start_button" onClick={() => { handleRunClick() }}>
                                        <img src={ico_ia_stars} />
                                        Lancez notre IA pour analyser le PLU
                                    </div>
                                </>
                            }
                        </>
                    } */}
                </div>
            </div>
            <div className="app__sectiondata_widget_spacer_20" onClick={() => { stopRunning() }}></div>
        </div>
    );
};

export default AIplu;